import axios from 'axios';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_USERS_ACTIVITY_MANAGER_API } from 'Constants/appEnvConstants'

// eslint-disable-next-line no-undef
const USER_ACTIVITY_MANAGER_API_BASE_URL = VITE_USERS_ACTIVITY_MANAGER_API;

export function getSummaryReport(reportName, startDate = null, endDate = null) {
  let url = `api/v1/useractivity/fetch/reports?reportName=${reportName}` + `&startDate=${startDate}&endDate=${endDate}`;
  configureHttpHeaders(axios);
  return get(url);
}

export function downloadSummaryReport(reportName, fileName) {
  let url = `api/v1/useractivity/reports/download`;
  return getBlob(USER_ACTIVITY_MANAGER_API_BASE_URL, url, reportName, fileName);
}

export function getDetailedProductivityReportcases(
  regionCode,
  queueId,
  userId,
  pageNumber,
  size,
  sort,
  queueSearchView,
  acquirerAccessCode,
) {
  let url = 'api/v1/useractivity/reports/detailed';
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });

  let data = {
    acquirerAccessCode: acquirerAccessCode,
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    queueId: queueId,
    queueSearchView: queueSearchView,
    regionCode: regionCode,
    size: size,
    userId: userId,
  };

  configureHttpHeaders(axios);
  return post(url, data);
}

function get(url) {
  return axios.get(`${USER_ACTIVITY_MANAGER_API_BASE_URL}${url}`).then(onSuccess).catch(onError);
}

function post(relativeURL, responseBody) {
  return axios({
    method: 'post',
    url: `${USER_ACTIVITY_MANAGER_API_BASE_URL}${relativeURL}`,
    data: responseBody,
  })
    .then(onSuccess)
    .catch(onError);
}

function getBlob(baseUrl, url, reportName, fileName) {
  axios.defaults.headers.common.Accept = 'application/octet-stream';
  configureHttpHeaders(axios);
  let resType = 'text/csv';

  const params = { fileName, reportName };

  return axios
    .get(`${baseUrl}${url}`, { params, responseType: 'arraybuffer' })
    .then(onSuccess)
    .then((response) => {
      const blob = new Blob([response], { type: resType });
      return blob;
    })
    .catch(onError);
}
